<template>
  <v-container class="pt-0 pb-15 px-0">
    <v-responsive max-width="1080" class="mx-auto">
      <v-card
        class="py-7"
        :class="titleHeaderClass"
        elevation="0"
        tile>
        <v-card-title class="justify-center text-h4 font-weight-black grey--text text--darken-2">お問い合わせ</v-card-title>
      </v-card>
      <v-card tile flat class="d-flex flex-column align-center mb-15">
        <v-card-title class="form_ttl mb-3">お問い合わせ完了</v-card-title>
        <v-card-text class="grey--text text--darken-4 text-body-1 mb-6">
          お問い合わせいただき、ありがとうございます。2日以内にご返答させていただきます。しばらくお待ちください。
        </v-card-text>
        <v-card-actions class="col-12">
          <v-btn
            :href="baseUrl"
            class="d-flex white--text text-subtitle-1 mx-auto rounded-lg pr-2 text-capitalize"
            color="#EF0B68"
            width="100%"
            max-width="240"
            height="60">{{ buttonLabel }}
            <v-icon right>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-responsive>
  </v-container>
</template>

<script>

export default {
  name: "inquiry-complete",
  props: {
    baseUrl: {
      type: String,
      default: '/'
    },
    titleHeaderClass: {
      type: String,
      default: "",
    },
    buttonLabel: {
      type: String,
      default: null
    }
  },
  mounted() {
    // ブラウザバックの抑制
    if (window.history && window.history.pushState) {
      history.pushState(null, null, location.href);
      window.addEventListener('popstate', (e) => {
        history.go(1);
      });
    }
  }
}
</script>
